import { Badge, Card, Image, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { PublicResponses } from "@tfg/types/endpoints/public"

import hanger from "~/assets/images/hanger.svg"
import shoe from "~/assets/images/shoe.svg"

type Props = {
  product: PublicResponses.ProductCard
}

export const ProductCardJonak = ({ product }: Props) => {
  const { t } = useTranslation("public")

  return (
    <Card
      radius="md"
      withBorder
      component="a"
      href={product.agecPopinUrl}
      target="_blank"
    >
      <Card.Section>
        <Image
          src={product.picture}
          alt={product.name}
          fit="fill"
          height={240}
          fallbackSrc={product.type.includes("FOOTWEAR") ? shoe : hanger}
        />
      </Card.Section>
      <Stack h={200} gap={4} mt="xs" justify="space-between">
        <Text
          // weight={600}
          style={{
            letterSpacing: "0.07em",
            fontFamily: "pragmatica",
          }}
        >
          {product.name}
        </Text>
        <Stack gap={4} align="flex-start" justify="flex-end">
          <Badge
            color="secondary.0"
            bg="primary.4"
            style={{
              letterSpacing: "0.07em",
              fontFamily: "pragmatica",
            }}
          >
            {product.collection}
          </Badge>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              // weight={400}
              style={{
                fontFamily: "freight-text-italic",
                letterSpacing: "normal",
              }}
            >
              {t("productCard.reference")}
            </Text>
            <Text
              // fw={700}
              style={{
                letterSpacing: "0.07em",
                fontFamily: "pragmatica",
              }}
            >
              {product.brandReference}
            </Text>
          </Stack>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              fw={400}
              style={{
                letterSpacing: "normal",
                fontFamily: "freight-text-italic",
              }}
            >
              {t("productCard.productType")}
            </Text>
            <Text
              // fw={700}
              style={{
                letterSpacing: "normal",
                fontFamily: "freight-text-regular",
              }}
            >
              {product.brandType}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
